import { formatDate } from 'utils/helpers';

export const REPAIRER_CAPACITY_REPORT = 'Repairer Capacity Report';

export const REPAIRER_CAPACITY_REPORT_MESSAGE =
  'Provides detailed information regarding a repairers historic performance against their future workload';

export const REPAIRER_CAPACITY_REPORT_GRID_HEADER = 'Capacity Report';

export const REPAIRER_CAPACITY_REPORT_GRID_TITLE = 'Rolling30DayReport';

export const reportHeaderTagLine = `Report produced on ${formatDate(new Date())}`;

